import { safeFetchAPI, SafeFetchResponse } from '../index'
import { API_BASE } from './index'
import { SignInStateResponse } from '../../types/widget'

/**
 * Get sign-in state (returns the loyalty signup link for shoppers without an
 * account). Used by both the rec-reward claim flow and the review flow to
 * render an "I need to sign up" CTA when the shopper has no contact record.
 *
 * NOTE: The old OTP-oriented `POST /widget/signin/:uid` and
 * `POST /widget/signin/:uid/verify` endpoints have been removed on BE.
 * Reviews now go through `src/api/widget/reviewsAuth.ts`
 * (`POST /widget/reviews/auth/{send,verify,refresh}`).
 */
export async function getSignInState(uid: string): Promise<SafeFetchResponse<SignInStateResponse>> {
  return safeFetchAPI<SignInStateResponse>(`${API_BASE}/widget/signin/${uid}`)
}
